var maxQuantity = 0

class BundleBuilder extends HTMLElement {
  constructor() {
    super()

    this.bundleParentId = this.dataset.productId
    this.boxId = ''
    this.currencyCode = 'USD'
    this.fixedDiscountTier = null
    this.percentDiscountTier = null
    this.oneTimeUpsells = []
    this.selectableProductVariants = []
    this.sellingPlanGroup = {}
    this.maxQuantity = 0
    this.items = []

    this.checkoutBtn = this.querySelector('.js-checkout')

    this.querySelectorAll('.js-bundle-nav').forEach(btn => {
      btn.addEventListener('click', this.handleNav.bind(this))
    })

    this.checkoutBtn.addEventListener('click', this.handleCheckout.bind(this))
    this.querySelector('.js-bundle-expand').addEventListener('click', this.handleExpand.bind(this))
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback () {
    this.fetchBundleData();

    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.handleQuantity, this.handleQuantity.bind(this));
  }

  disconnectedCallback () {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  handleNav (e) {
    const nextStep = e.target.dataset.step;
    this.querySelectorAll('.js-bundle-step').forEach(node => {
      if (node.dataset.step === nextStep) {
        node.classList.remove('hidden')
      } else {
        node.classList.add('hidden')
      }
    })

    const headerHeight = document.querySelector('.shopify-section--header').getBoundingClientRect().height;

    window.scrollTo({
      top: this.getBoundingClientRect().top + window.scrollY - headerHeight - 10,
      behavior: 'smooth'
    })
  }

  handleExpand () {
    this.querySelector('.js-step-2').classList.remove('hidden')
    this.querySelector('.js-bundle-expand').classList.add('hidden')
  }

  handleQuantity (payload) {
    const items = this.items.filter(item => item.id !== payload.id)
    this.items = [...items, payload]

    publish(PUB_SUB_EVENTS.updateItems, {
      items: this.items
    })

    const totalBundleQuantity = this.items.filter(item => item.subscribe)
      .map(item => item.quantity)
      .reduce((a, b) => a + b, 0)

    if (totalBundleQuantity === 2) {
      this.checkoutBtn.removeAttribute('disabled')
      this.querySelector('.js-bundle-expand').removeAttribute('disabled')
    } else {
      this.checkoutBtn.setAttribute('disabled', true)
      this.querySelector('.js-bundle-expand').classList.remove('hidden')
      this.querySelector('.js-bundle-expand').setAttribute('disabled', true)
      this.querySelector('.js-step-2').classList.add('hidden')
    }
  }

  async handleCheckout () {
    const cart = await fetch('/cart.js').then(res => res.json())
    const boxIndex = Math.max(...cart.items.map(item => item?.properties?._dynamicBoxIndex).filter(e => !!e), -1) + 1

    const sellingPlan = this.querySelector('[name="selling_plan"]:checked').value
    const subscribeItems = this.items.filter(item => item.subscribe && item.quantity > 0)
      .map(item => ({
        id: parseInt(item.id),
        quantity: item.quantity,
        selling_plan: sellingPlan,
        properties: {
          _dynamicBoxId: this.boxId,
          _dynamicBoxIndex: boxIndex
        }
      }))
    const oneTimeItems = this.items.filter(item => !item.subscribe && item.quantity > 0)
      .map(item => ({
        id: parseInt(item.id),
        quantity: item.quantity,
        _dynamicBoxUpsell: true
      }))

    const items = [...subscribeItems, ...oneTimeItems]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    }).then(res => res.json())
    .then(res => {
      window.location.href = '/checkout'
    })
  }

  async fetchBundleData () {
    const resp = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
      method: 'POST',
      body: JSON.stringify({
        'productPlatformId': this.bundleParentId,
      })
    }).then((response) => response.json())

    const { boxId, currencyCode, fixedDiscountTier, percentDiscountTier, oneTimeUpsells, selectableProductVariants, sellingPlanGroup, sizeInterval, sizeRange } = resp.DynamicBox

    this.boxId = boxId
    this.currencyCode = currencyCode
    this.fixedDiscountTier = fixedDiscountTier
    this.percentDiscountTier = percentDiscountTier
    this.oneTimeUpsells = oneTimeUpsells
    this.selectableProductVariants = selectableProductVariants
    this.sellingPlanGroup = sellingPlanGroup
    this.maxQuantity = sizeRange || sizeInterval[0]
    maxQuantity = this.maxQuantity

    this.renderBundleItems()
    this.renderAddonItems()
    this.renderSellingPlans()

    publish(PUB_SUB_EVENTS.initConfiguration, {
      fixedDiscountTier,
      percentDiscountTier,
      maxQuantity: this.maxQuantity,
      selectableProductVariants,
      oneTimeUpsells
    })
  }

  renderBundleItems () {
    const snippets = this.selectableProductVariants.map(item => {
      return this.buildBundleItemHtml(item, true)
    }).join('')

    this.querySelector('.js-bundle-items').innerHTML = snippets
  }

  renderAddonItems () {
    const snippets = this.oneTimeUpsells.map(item => {
      return this.buildBundleItemHtml(item, false)
    }).join('')

    this.querySelector('.js-onetimes-list').innerHTML = snippets
  }

  buildBundleItemHtml (item, isSubscribe = false) {
    const variantId = item.productVariants[0].platformId.split('/').pop()

    return `
      <bundle-item>
        <form class="js-bundle-item-form">
          <input type="hidden" name="id" value="${variantId}"/>
          <input type="hidden" name="subscribe" value="${isSubscribe}"/>
          <div class="bundle-item h-stack text-center">
            <div class="bundle-item__image">
              <img src="${item.productImageSrc}">
            </div>

            <p class="bundle-item__title text-lg">${item.productTitle}</p>
            <p class="bundle-item__price bold text-lg">$${item.productVariants[0].price}</p>

            <div class="bundle-item__divider">
              <hr>
            </div>

            <div class="h-stack quantity-selector">
              <button type="button" class="quantity-selector__button js-qty-update" data-action="minus">
                <svg height="12" width="12" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M24 12a2 2 0 01-2 2H2a2 2 0 110-4h20a2 2 0 012 2z"></path></svg>
              </button>

              <input class="quantity-selector__input" type="number" name="quantity" value="0" readOnly min="0"/>

              <button type="button" class="quantity-selector__button js-qty-update" data-action="plus">
                <svg height="12" width="12" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M22 10h-8V2a2 2 0 0 0-4 0v8H2a2 2 0 0 0 0 4h8v8a2 2 0 0 0 4 0v-8h8a2 2 0 0 0 0-4"></path></svg>
              </button>
            </div>
          </div>
        </form>
      </bundle-item>
    `
  }

  renderSellingPlans () {
    const snippets = Object.keys(this.sellingPlanGroup).map((key, index) => {
      const sellingPlan = this.sellingPlanGroup[key]

      return `
        <div class="bundle-selling-plan">
          <input type="radio" name="selling_plan" value="${key.split('/').pop()}" ${sellingPlan.intervalCount === 4 ? 'checked' : ''} id="selling-plan-${index}">
            <label class="text-lg" for="selling-plan-${index}">
            ${sellingPlan.title}
          </label>
        </div>
      `
    }).join('')

    this.querySelector('.js-selling-plans').innerHTML = snippets
  }
}

customElements.define('bundle-builder', BundleBuilder)

class BundleItem extends HTMLElement {
  constructor() {
    super();
    this.quantitySelector = this.querySelector('[name="quantity"]')
    this.quantity = parseInt(this.quantitySelector.value);
    this.id = this.querySelector('[name="id"]').value
    this.total = Number(this.dataset.total || 0)
    this.isSubscribe = (this.querySelector('[name="subscribe"]').value === 'true')
    this.clearBtn = this.querySelector('.js-qty-clear')

    this.querySelectorAll('.js-qty-update').forEach(btn => {
      btn.addEventListener('click', this.handleQuantity.bind(this))
    })

    if (!!this.clearBtn) this.clearBtn.addEventListener('click', this.handleRemove.bind(this));
  }

  bundleUpdateUnsubscriber = null
  quantityUpdateUnsubscriber = null

  connectedCallback () {
    this.bundleUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.updateItems, this.handleBundleUpdate.bind(this));
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.handleQuantity, this.quantitySubscribe.bind(this));
    this.max = maxQuantity
  }

  disconnectedCallback () {
    if (this.bundleUpdateUnsubscriber) {
      this.bundleUpdateUnsubscriber();
    }

    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  handleBundleUpdate (data) {
    const { items } = data
    this.total = items.filter(item => item.subscribe)
      .map(item => item.quantity)
      .reduce((a, b) => a + b, 0)
  }

  quantitySubscribe (data) {
    if (data.id === this.id) {
      this.quantity = data.quantity
      this.quantitySelector.value = data.quantity
    }
  }

  handleQuantity (e) {
    const button = e.target.closest('.js-qty-update')
    const { action } = button.dataset

    if (action === 'plus') {
      if (this.total + 1 > this.max && this.isSubscribe) return;

      this.quantity = this.quantity + 1
    } else {
      this.quantity = Math.max(this.quantity - 1, 0)
    }

    this.quantitySelector.value = this.quantity

    publish(PUB_SUB_EVENTS.handleQuantity, {
      quantity: this.quantity,
      id: this.id,
      subscribe: this.isSubscribe
    })
  }

  handleRemove () {
    this.quantity = 0
    this.quantitySelector.value = 0

    publish(PUB_SUB_EVENTS.handleQuantity, {
      quantity: this.quantity,
      id: this.id,
      subscribe: this.isSubscribe
    })
  }
}

customElements.define('bundle-item', BundleItem)

class BundleSelections extends HTMLElement {
  constructor() {
    super();
    this.selectableProductVariants = []
    this.oneTimeUpsells = []
    this.discountRules = []
    this.bundleItems = []
    this.onetimeItems = []
    this.products = []
    this.onetimes = []
    this.discount = 0
    this.discountType = 'fixed'
    this.totalQuantity = 0
  }

  bundleUpdateUnsubscriber = null
  initUnsubscriber = null

  connectedCallback () {
    this.bundleUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.updateItems, this.handleBundleUpdate.bind(this));
    this.initUnsubscriber = subscribe(PUB_SUB_EVENTS.initConfiguration, this.initConfiguration.bind(this))
  }

  disconnectedCallback () {
    if (this.bundleUpdateUnsubscriber) {
      this.bundleUpdateUnsubscriber();
    }

    if (this.initConfiguration) {
      this.initConfiguration();
    }
  }

  initConfiguration (data) {
    this.selectableProductVariants = data.selectableProductVariants
    this.oneTimeUpsells = data.oneTimeUpsells

    if (!!data.percentDiscountTier) this.discountType = 'percent';

    this.discountRules = Object.keys(data.fixedDiscountTier || data.percentDiscountTier).map(quantity => ({
      quantity: parseInt(quantity),
      value: (data.fixedDiscountTier || data.percentDiscountTier)[quantity]
    }))
  }

  handleBundleUpdate (data) {
    const { items } = data
    this.bundleItems = items.filter(item => item.subscribe && item.quantity > 0)
    this.onetimeItems = items.filter(item => !item.subscribe && item.quantity > 0)
    this.bundleQuantity = this.bundleItems
      .map(item => item.quantity)
      .reduce((a, b) => a + b, 0)

    this.totalQuantity = this.bundleQuantity + this.onetimeItems.map(item => item.quantity)
      .reduce((a, b) => a + b, 0)

    this.discount = Number((this.discountRules.find(rule => this.bundleQuantity >= rule.quantity) || { value: 0 }).value);
    this.products = this.bundleItems.map(item => {
      return this.selectableProductVariants.find(p => p.productVariants.map(v => v.platformId).includes(`gid://shopify/ProductVariant/${item.id}`))
    });

    this.onetimes = this.onetimeItems.map(item => {
      return this.oneTimeUpsells.find(p => p.productVariants.map(v => v.platformId).includes(`gid://shopify/ProductVariant/${item.id}`))
    });

    this.buildBundleSummary ()
    this.buildBundleReviews()
  }

  buildBundleSummary () {
    const bundleSnippets = this.products.map(product => {
      const discountedPrice = this.discountType === 'percent' ? product.productVariants[0].price * (100 - this.discount) / 100
        : product.productVariants[0].price - (this.discount / this.bundleQuantity);

      return `
        <div class="bundle-selection-item">
          <div class="bundle-item__image">
            <img src="${product.productImageSrc}">
          </div>

          <p class="bundle-item__title text-lg">${product.productTitle}</p>
          <p class="bundle-item__price h-stack justify-center bold text-lg">
            <span class="${this.discount > 0 ? 'line-through' : ''}">${window.formatMoney(product.productVariants[0].price * 100)}</span>
            ${this.discount > 0 ? `<span class="text-success">${window.formatMoney(discountedPrice * 100)}</span>` : ''}
          </p>
        </div>
      `
    }).join('')

    const onetimeSnippets = this.onetimeItems.map(item => {
      const product = this.oneTimeUpsells.find(p => p.productVariants.map(v => v.platformId).includes(`gid://shopify/ProductVariant/${item.id}`))

      return `
        <div class="bundle-selection-item">
          <div class="bundle-item__image">
            <img src="${product.productImageSrc}">
          </div>

          <p class="bundle-item__title text-lg">${product.productTitle}</p>
          <p class="bundle-item__price h-stack justify-center bold text-lg">
            ${window.formatMoney(product.productVariants[0].price * 100)} ${item.quantity > 1 ? ` X ${item.quantity}` : ''}
          </p>
        </div>
      `
    }).join('')

    if (!!this.querySelector('.js-bundle-selections')) this.querySelector('.js-bundle-selections').innerHTML = `${bundleSnippets}${onetimeSnippets}`;

    const totalPrice = this.bundleItems.map(item => {
      const product = this.selectableProductVariants.find(p => p.productVariants.map(v => v.platformId).includes(`gid://shopify/ProductVariant/${item.id}`))
      return product.productVariants[0].price * item.quantity
    }).reduce((a, b) => a + b, 0)

    const subtotalBundle = this.discountType === 'fixed' ? totalPrice - this.discount : totalPrice * (100 - this.discount) / 100;
    const subtotalOnetime = this.onetimeItems.map(item => {
      const product = this.oneTimeUpsells.find(p => p.productVariants.map(v => v.platformId).includes(`gid://shopify/ProductVariant/${item.id}`))
      return product.productVariants[0].price * item.quantity
    }).reduce((a, b) => a + b, 0)

    const subtotal = subtotalBundle + subtotalOnetime

    this.querySelector('.js-bundle-selections-summary').innerHTML = `
      <tbody>
        <tr><td class="text-start">Items</td><td class="text-end">${this.totalQuantity}</td></tr>
        ${this.discount > 0 ? `<tr><td class="text-start">Discount</td><td class="text-end">${this.discountType === 'percent' ? this.discount: window.formatMoney(this.discount * 100)}${this.discountType === 'percent' ? '%' : ''}</td></tr>` : ''}
        <tr><td class="text-start">Subtotal</td><td class="text-end text-success bold">${window.formatMoney(subtotal * 100)}</td></tr>
      </tbody>
    `
  }

  buildBundleReviews () {
    const snippets = this.bundleItems.map(item => {
      const product = this.selectableProductVariants.find(p => p.productVariants.map(v => v.platformId).includes(`gid://shopify/ProductVariant/${item.id}`))
      const discountedPrice = this.discountType === 'percent' ? product.productVariants[0].price * (100 - this.discount) / 100
        : product.productVariants[0].price - (this.discount / this.totalQuantity);
      return `
        <tr>
          <td>
            <div class="line-item">
              <img
                src="${product.productImageSrc}"
                class="line-item__media"
              >
              <div class="line-item-info">
                <div class="v-stack justify-items-start gap-2">
                  <div class="v-stack justify-items-start gap-1">
                    ${product.productTitle}

                    <div class="bundle-item__price h-stack bold text-lg sm:hidden">
                      <p class="${this.discount > 0 ? 'line-through' : ''}">${window.formatMoney(product.productVariants[0].price * 100)}</p>
                      ${this.discount > 0 ? `<p class="text-success">${window.formatMoney(discountedPrice * 100)}</p>` : ''}
                    </div>
                  </div>
                  <div class="h-stack gap-4 sm:hidden">
                    <bundle-item data-total="${this.totalQuantity}">
                      <form class="js-bundle-item-form v-stack gap-1 mobile">
                        <input type="hidden" name="id" value="${item.id}"/>
                        <input type="hidden" name="subscribe" value="true"/>
                        <div class="h-stack quantity-selector">
                          <button type="button" class="quantity-selector__button js-qty-update" data-action="minus">
                            <svg height="12" width="12" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M24 12a2 2 0 01-2 2H2a2 2 0 110-4h20a2 2 0 012 2z"></path></svg>
                          </button>

                          <input class="quantity-selector__input" type="number" name="quantity" value="${item.quantity}" readOnly min="0"/>

                          <button type="button" class="quantity-selector__button js-qty-update" data-action="plus">
                            <svg height="12" width="12" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M22 10h-8V2a2 2 0 0 0-4 0v8H2a2 2 0 0 0 0 4h8v8a2 2 0 0 0 4 0v-8h8a2 2 0 0 0 0-4"></path></svg>
                          </button>
                        </div>

                        <div>
                          <button type="button" class="link js-qty-clear">
                            Remove
                          </button>
                        </div>
                      </form>
                    </bundle-item>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td class="text-center">
            <div class="v-stack justify-items-center gap-2">
              <bundle-item data-total="${this.totalQuantity}">
                <form class="js-bundle-item-form v-stack gap-1 desktop">
                  <input type="hidden" name="id" value="${item.id}"/>
                  <input type="hidden" name="subscribe" value="true"/>
                  <div class="h-stack quantity-selector">
                    <button type="button" class="quantity-selector__button js-qty-update" data-action="minus">
                      <svg height="12" width="12" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M24 12a2 2 0 01-2 2H2a2 2 0 110-4h20a2 2 0 012 2z"></path></svg>
                    </button>

                    <input class="quantity-selector__input" type="number" name="quantity" value="${item.quantity}" readOnly min="0"/>

                    <button type="button" class="quantity-selector__button js-qty-update" data-action="plus">
                      <svg height="12" width="12" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M22 10h-8V2a2 2 0 0 0-4 0v8H2a2 2 0 0 0 0 4h8v8a2 2 0 0 0 4 0v-8h8a2 2 0 0 0 0-4"></path></svg>
                    </button>
                  </div>

                  <div>
                    <button type="button" class="link js-qty-clear">
                      Remove
                    </button>
                  </div>
                </form>
              </bundle-item>
            </div>
          </td>

          <td class="text-end">
            <div class="bundle-item__price h-stack bold text-lg justify-end">
              <p class="${this.discount > 0 ? 'line-through' : ''}">$${product.productVariants[0].price}</p>
              ${this.discount > 0 ? `<p class="text-success">$${discountedPrice}</p>` : ''}
            </div>
          </td>
        </tr>
      `
    }).join('')

    if (!!this.querySelector('.js-bundle-review-items')) this.querySelector('.js-bundle-review-items').innerHTML = snippets
  }
}

customElements.define('bundle-selections', BundleSelections)
